export default {
  LEAVE: {
    DETAILS: "Butiran",
    ENTITLE: "Kelayakan Cuti",
    AA: "Pengagihan Cuti",
    APPROVAL: "Pengesahanan Permohonan",
    STAT: "Statistik",
    LEAVEDETAILS: "Tambah Jenis Cuti",
    LEAVETYPE: "Butiran Cuti",
    TYPE: "Jenis Cuti",
    ENTITLEMENT: "Kelayakan Cuti",
    APPLICATION: "Pengesahan Permohonan",
    APPLICATION_TITLE: "Permohonan Cuti",
    ASSIGNMENT_TITLE: "Pengagihan Cuti ",
    STATISTICS: "Statistik",
    LEAVEAPPLICATION: "Permohonan Cuti",
    EMPLEAVE: "Cuti Pekerja",
    APP: "Permohonan",
    APPLY: "Mohon Cuti",
    APPLYNEW: "Mohon {leave}",
    HOVER: {
      EDIT: "Sunting Cuti",
      DELETE: "Buang Cuti",
      NAVIGATEENT: "Navigasi ke Kehadiran Cuti",
      NAVIGATEASS: "Navigasi ke Pengagihan Cuti",
      EDITENT: "Sunting Kehadiran Cuti",
      ASSIGNLEAVE: "Agih Cuti",
    },
  },
  DETAILSTABLE: {
    TYPE: "JENIS CUTI",
    DESC: "PENERANGAN",
    UNIT: "UNIT CUTI",
    COUNT: "KIRAAN HARI",
    PAID: "CUTI BERBAYAR",
    ACT: "TINDAKAN",
  },
  DETAILSFORM: {
    TYPE: "Jenis Cuti",
    TYPE1: "Masukkan Jenis Cuti",
    DESC: "Penerangan",
    DESC1: "(200 karakter maksimum)",
    UNIT: "Unit Cuti",
    COUNT: "Kiraan Hari",
    PAID: "Cuti Berbayar?",
  },
  ENTITLEMENT: {
    CREATE: "Tambah Kelayakan Cuti",
    DETAILS: "Butiran Kelayakan Cuti",
    TYPE: "Jenis Cuti",
    DAYS: "Bilangan Hari Kelayakan Cuti",
    OVER: "Carried Over (in malay)",
    VALID: "Sah Sehingga",
    BALANCE: "Baki",
    REASON: "Alasan",
    PENDING: "Belum Diproses",
    BALANCE1: "Baki cuti",
    REASON1: "Masukkan Alasan",
    DAY: "Hari",
    SESSION: "Sesi",
    ATTACHMENT: "Lampiran",
    PURPOSE: "Untuk Kegunaan Pengurusan",
    APPLICATION: "Tarikh Permohonan",
    SESSION1: "Masukkan Sesi",
    APPROVE: "Sahkan",
    ATTACHMENT1: "Pilih Fail",
  },
  STATISTICS: {
    WEEK: "Minggu",
    PENDING: "Belum Diproses",
    APPROVED: "Disahkan",
    TOTAL: "Jumlah",
    WEEK1: "Minggu :",
    NEW: "Permohonan Baru",
    MONTH: "Bulan",
    YEAR: "Tahun",
  },
};
